<template>
    <div>
        <!--  BREAKDOWN NOT INCLUDED -->
        <div class="summary-details px-4 row my-2 mt-3" v-if="summary.totalRate.breakdownExcluded.length">
            <div class="col-12">
                <span class="font-weight-bold">{{ __('breakdown.charges_not_included') }}</span>
                <!-- <br><span class="text-muted font-12">{{ __('messages.charges_not_included_sub') }}</span> -->
            </div>
        </div>
        <div class="summary-details px-4 row mb-2" v-for="breakdown in summary.totalRate.breakdownExcluded"
            :key="breakdown.title">
            <div v-if="breakdown.title == 'TaxExcluded' && summary.rate.country == 'CO'">
                <div class="d-flex">
                    <div class="col-7 d-flex justify-content-start">
                        {{ __(`breakdown.${breakdown.title}_${summary.rate.country}`) }} <i @click="openaModalResidents()"
                            style="font-size: 17px;cursor: pointer;"
                            class="font-icons btnTertiary icons-info align-bottom"></i>
                    </div>
                    <div class="col-5 d-flex justify-content-end"
                        v-if="(source?.includes('trivago') ||  source?.includes('google')) && breakdown.originalCurrency && breakdown.originalCurrency != currencySite">
                        <currency-display :amount="breakdown.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>*
                    </div>
                </div>
                <div class="col-12">
                    <residents-colo :breakdown="breakdown"></residents-colo>
                </div>
            </div>

            <div class="col-7 d-flex justify-content-start" :class="{'col-12': !((source?.includes('trivago') || source?.includes('google')) && breakdown.title != 'TaxExcluded' && breakdown.originalCurrency && breakdown.originalCurrency != currencySite)}" v-else>
                {{ __(`breakdown.${breakdown.title}`) }} <i v-if="breakdown.title == 'HotelMandatoryTax' && summary.rate.country == 'PE'" @click="openaModalResidentsPeru()"
                            style="font-size: 17px;cursor: pointer;"
                            class="font-icons btnTertiary icons-info align-bottom"></i>
            </div>
            <div class="col-5 d-flex justify-content-end"
                v-if="(source?.includes('trivago') || source?.includes('google')) && breakdown.title != 'TaxExcluded' && breakdown.originalCurrency && breakdown.originalCurrency != currencySite">
                <currency-display :amount="breakdown.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>*
            </div>
            <div class="col-12 text-muted font-12" v-if="breakdown.title != 'TaxExcluded'">
                <span v-if="breakdown.title == 'HospitalityTax'"><currency-display :amount="breakdown.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display></span>
                <span v-else>
                    <span v-if="breakdown.originalCurrency">
                        <span v-if="source?.includes('trivago') || source?.includes('google')">*</span>
                        {{breakdown.originalAmount | currencyBaseFee(breakdown.originalCurrency, 2) }}
                    </span>
                    <span v-else> <currency-display :amount="breakdown.amount" :showCurrencyCode="true" :applyDecimals="true"></currency-display></span>
                </span>
                {{ __(`breakdown.${breakdown.title}_sub`) }}
            </div>
        </div>
        <section
            v-if="(source?.includes('trivago') || source?.includes('google')) && summary.totalRate.breakdownExcluded.length && isMetaTotal">
            <hr class="ml-2 mr-2 mb-0 mt-0" />
            <div class="summary-details px-4 row mb-2 mt-2">
                <div class="col-7 d-flex justify-content-start text-muted font-12">
                    {{ __('messages.source_triv_gool') }}
                </div>
                <div class="col-5 d-flex justify-content-end text-muted font-12">
                    <currency-display :amount="totalExluded + summary.totalRate.totalAmount" :showCurrencyCode="true" :applyDecimals="true"></currency-display>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    props: {
        summary: {},
        source: "",
        isMetaTotal: false,
        currencySite: ""
    },
    data() {
        return {
            totalExluded: 0
        }
    },
    components: {
    },
    methods : {
        openaModalResidents() {
            $("#modal-residents-colo").modal("show")
        },
        openaModalResidentsPeru() {
            $("#modal-residents-peru").modal("show")
        }
    },
    mounted() {
        this.totalExluded = this.summary.totalRate.breakdownExcluded.length > 0 ? this.summary.totalRate.breakdownExcluded.reduce((accum, item) => accum + item.amount, 0) : 0;

        if(this.summary.rate.country == 'MX') {
            this.summary.totalRate.breakdownExcluded = this.summary.totalRate.breakdownExcluded.filter(breakdown=>breakdown.title != 'TaxExcluded')            
        }
    }
}
</script>